export const TransactionActionTypes = {
  FETCH_BUY_REQUEST: "@@Transaction/FETCH_BUY_REQUEST",
  FETCH_BUY_SUCCESS: "@@Transaction/FETCH_BUY_SUCCESS",
  FETCH_BUY_FAILURE: "@@Transaction/FETCH_BUY_FAILURE",

  CREATE_BUY_REQUEST: "@@Transaction/CREATE_BUY_REQUEST",
  CREATE_BUY_SUCCESS: "@@Transaction/CREATE_BUY_SUCCESS",
  CREATE_BUY_FAILURE: "@@Transaction/CREATE_BUY_FAILURE",

  FETCH_SELL_REQUEST: "@@Transaction/FETCH_SELL_REQUEST",
  FETCH_SELL_SUCCESS: "@@Transaction/FETCH_SELL_SUCCESS",
  FETCH_SELL_FAILURE: "@@Transaction/FETCH_SELL_FAILURE",

  FETCH_PAYOUT_REQUEST: "@@Transaction/FETCH_PAYOUT_REQUEST",
  FETCH_PAYOUT_SUCCESS: "@@Transaction/FETCH_PAYOUT_SUCCESS",
  FETCH_PAYOUT_FAILURE: "@@Transaction/FETCH_PAYOUT_FAILURE",

  FETCH_PLANMEMBER_REQUEST: "@@Transaction/FETCH_PLANMEMBER_REQUEST",
  FETCH_PLANMEMBER_SUCCESS: "@@Transaction/FETCH_PLANMEMBER_SUCCESS",
  FETCH_PLANMEMBER_FAILURE: "@@Transaction/FETCH_PLANMEMBER_FAILURE",

  FETCH_CONTRACT_REQUEST: "@@Transaction/FETCH_CONTRACT_REQUEST",
  FETCH_CONTRACT_SUCCESS: "@@Transaction/FETCH_CONTRACT_SUCCESS",
  FETCH_CONTRACT_FAILURE: "@@Transaction/FETCH_CONTRACT_FAILURE",

  CREATE_SELL_REQUEST: "@@Transaction/CREATE_SELL_REQUEST",
  CREATE_SELL_SUCCESS: "@@Transaction/CREATE_SELL_SUCCESS",
  CREATE_SELL_FAILURE: "@@Transaction/CREATE_SELL_FAILURE",

  FETCH_WITHDRAW_REQUEST: "@@Transaction/FETCH_WITHDRAW_REQUEST",
  FETCH_WITHDRAW_SUCCESS: "@@Transaction/FETCH_WITHDRAW_SUCCESS",
  FETCH_WITHDRAW_FAILURE: "@@Transaction/FETCH_WITHDRAW_FAILURE",

  CREATE_WITHDRAW_REQUEST: "@@Transaction/CREATE_WITHDRAW_REQUEST",
  CREATE_WITHDRAW_SUCCESS: "@@Transaction/CREATE_WITHDRAW_SUCCESS",
  CREATE_WITHDRAW_FAILURE: "@@Transaction/CREATE_WITHDRAW_FAILURE",

  UPDATE_WITHDRAW_REQUEST: "@@Transaction/UPDATE_WITHDRAW_REQUEST",
  UPDATE_WITHDRAW_SUCCESS: "@@Transaction/UPDATE_WITHDRAW_SUCCESS",
  UPDATE_WITHDRAW_FAILURE: "@@Transaction/UPDATE_WITHDRAW_FAILURE",

  UPDATE_PLANMEMBER_REQUEST: "@@Transaction/UPDATE_PLANMEMBER_REQUEST",
  UPDATE_PLANMEMBER_SUCCESS: "@@Transaction/UPDATE_PLANMEMBER_SUCCESS",
  UPDATE_PLANMEMBER_FAILURE: "@@Transaction/UPDATE_PLANMEMBER_FAILURE",
};

